<template>
  <Form ref="form" :model="form" :rules="ruleValidate" label-position="left" :label-width="80">
    <FormItem label="上级类型">
      <Select v-model="form.pid" :placeholder="'上级稿件类型'" filterable clearable>
        <Option v-for="(item, index) in pidList" :value="item.alis" :key="index">{{ item.title }}</Option>
      </Select>
    </FormItem>
    <FormItem label="标题" prop="title">
      <Input v-model="form.title" placeholder="请输入标题"></Input>
    </FormItem>
    <FormItem v-if="!form.pid||form.pid==0" label="别名" prop="alis">
      <Input v-model="form.alis" placeholder="请输入别名"></Input>
    </FormItem>
    <FormItem>
      <Button type="primary" :loading="loading" @click="handleSubmit('form')">保存数据</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {

  props: {
    condition: {
      type: [Boolean, Number, String, Array,Object],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        //全部
        library_id: localStorage.getItem('libId'),
        title: '',//标题
        alis:'',//别名
        pid:0,//上级稿件类型
      },

      ruleValidate: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        alis: [
          {required: true, message: '请输入别名', trigger: 'blur'},
        ],
      },

      pidList:[]
    }
  },
  methods: {
    /*****************************************************************
     * 表单验证
     * @param   {name}             要验证的表单名称
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          if(this.form.pid&&this.form.pid!=0){
            this.form.alis = ''
          }
          !this.condition ? this.addSubmit() : this.editSubmit()
        } else {
          this.loading = false
          this.$Message.error('请核对输入内容!');
        }
      })
    },

    /*****************************************************************
     * 添加数据
     *****************************************************************/
    addSubmit() {
      this.$httpsencrypt.post('api/contributeweb/v3/manuscriptclass/add', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false
        this.$Message.success('添加成功!');
      }).catch(err => {
        this.loading = false
      })
    },

    /*****************************************************************
     *
     * 修改数据
     *
     *****************************************************************/
    editSubmit() {
      if (typeof this.form.pid == "undefined")
        this.form.pid = '0'
      this.$set(this.form,'id',this.condition.manuscript_class_id)
      this.$httpsencrypt.post('api/contributeweb/v3/manuscriptclass/edit', this.form).then(val => {
        this.$emit('operationState', true)
        this.loading = false;
        this.$Message.success('修改成功!');
      }).catch(err => {
        this.loading = false;
      })

    },

    /*****************************************************************
     *
     * 单条查询数据
     *
     *****************************************************************/
    selData() {
      this.loading = true
      this.form.title = this.condition.title
      this.form.alis = this.condition.alis
      this.form.pid = this.condition.pid
    },
    /*****************************************************************
     *
     * 获取上级稿件
     *
     *****************************************************************/
    getPidList() {
      const _this = this
      let cond = {
        library_id:localStorage.getItem('libId'),
        pid:0
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscriptclass/index`,cond)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.pidList = val.data
            }else {
              _this.pidList = []
            }
            _this.loading = false;
          }).catch(err =>{
        _this.pidList = []
        _this.loading = false;
      })
    },

  },
  mounted() {
    this.getPidList()
    if (this.condition) this.selData()
  }
};
</script>
